import { ColumnEditorOptions } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { ChangeEvent, useState } from "react";

interface TextEditorProps {
    options: ColumnEditorOptions;
    maxLength?: number;
}

export const TextEditor = ({ options, maxLength }: TextEditorProps) => {
    // Seed once so the existing text shows on open and survives re-renders.
    const [value, setValue] = useState(() => String(options.value ?? ""));

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.target.value);
        options.editorCallback?.(event.target.value);
    };

    return (
        <InputTextarea
            className="w-full"
            autoResize
            autoFocus
            value={value}
            onChange={handleChange}
            maxLength={maxLength}
        />
    );
};
